import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { AppRoutes } from '../AppRoutes';

const ResetPasswordPage = lazy(() =>
  import('@/pages/auth').then((module) => ({
    default: module.ResetPasswordPage,
  }))
);

const ResetPasswordTokenPage = lazy(() =>
  import('@/pages/auth').then((module) => ({
    default: module.ResetPasswordTokenPage,
  }))
);

const CheckYourEmailRegisterPage = lazy(() =>
  import('@/pages/auth').then((module) => ({
    default: module.CheckYourEmailRegisterPage,
  }))
);

const CheckYourEmailAfterResetPasswordPage = lazy(() =>
  import('@/pages/auth').then((module) => ({
    default: module.CheckYourEmailAfterResetPasswordPage,
  }))
);

const VerifyUserPage = lazy(() =>
  import('@/pages/auth').then((module) => ({
    default: module.VerifyUserPage,
  }))
);

const InvitationAcceptancePage = lazy(() =>
  import('@/pages/user-invitation').then((module) => ({
    default: module.InvitationAcceptancePage,
  }))
);

export const commonRouter: RouteObject[] = [
  {
    path: AppRoutes.VERIFY_USER,
    element: <VerifyUserPage />,
  },

  {
    path: AppRoutes.VERIFY,
    element: <VerifyUserPage />,
  },

  {
    path: AppRoutes.RESET_PASSWORD,
    element: <ResetPasswordPage />,
  },
  {
    path: AppRoutes.RESET_PASSWORD_TOKEN,
    element: <ResetPasswordTokenPage />,
  },
  {
    path: AppRoutes.CHECK_YOUR_EMAIL_RESET_PASSWORD,
    element: <CheckYourEmailAfterResetPasswordPage />,
  },
  {
    path: AppRoutes.CHECK_YOUR_EMAIL_REGISTER,
    element: <CheckYourEmailRegisterPage />,
  },
  {
    path: AppRoutes.INVITATION_ACCEPTANCE,
    element: <InvitationAcceptancePage />,
  },
];
